<div class="mb-2">
  <h1 class="main-title">Mantenedores > Usuarios</h1>
</div>

<div class="single-page-content !pt-12">
  <div class="flex justify-between items-center mb-4 gap-4 filter-container">

    <!-- <button class="button button-primary button-sm" (click)="newUser()">
      Nuevo usuario
    </button> -->

  </div>

  <app-table class="table-news table-switch" [columns]="tableColumns" [data]="users" [pageSizeOptions]="[20, 50, 100]"
    [initialPageSize]="20">
    <ng-template #actionTemplate let-user>
      <div class="action-buttons">

        <button title="Ver" (click)="onlyReadUser(user)">
          <img src="assets/icons/eye-icon.svg" alt="" />
        </button>

        <button title="Editar" (click)="editUser(user)">
          <img src="assets/icons/pencil-icon.svg" alt="" />
        </button>

      </div>
    </ng-template>
  </app-table>
</div>